import { AskForConfirmation } from "uikit"
import React, { useState } from "react"
import { Redirect } from "react-router-dom"
import { Dropdown, Grid, Input } from "semantic-ui-react"
import { useStore } from "store"
import { CreateScenarioModal } from "./Scenario/CreateScenarioModal"

const ScenarioView = ({ render, household, user }) => {
  const [scenarios, { updateScenario }] = useStore(
    "householdScenarios",
    household.id
  )
  const [privileges] = useStore("privileges", user.group_id)
  const [householdState] = useStore("householdState", household.id)
  return (
    <ScenarioSelector
      user={user}
      householdState={householdState}
      householdId={household.id}
      canCreateScenario={!!privileges["scenario:create"]}
      updateScenario={updateScenario}
      render={render}
      scenarios={Object.values(scenarios)}
      household={household}
    />
  )
}

const ScenarioSelector = props => {
  const [state, setState] = useState({
    loading: false,
    renameMode: false,
    createMode: false,
    requestScenarioSucceeded: false,
    deleteFailed: false,
    deleteSucceeded: false,
    scenarioTitle: null
  })

  const [
    scenario,
    { createScenario, deleteScenario, updateHouseholdState }
  ] = useStore("scenarios", props.householdState.currentScenarioId)

  const updateScenarioTitle = async () => {
    setState(cur => ({ ...cur, loading: true }))
    if (!state.scenarioTitle) {
      setState(cur => ({
        ...cur,
        scenarioTitle: scenario.description || "Untitled"
      }))
    } else {
      if (state.scenarioTitle !== scenario.description) {
        await props.updateScenario({
          id: scenario.id,
          description: state.scenarioTitle
        })
      }
    }
    setState(cur => ({ ...cur, renameMode: false, loading: false }))
  }

  if (!props.householdState.currentScenarioId) {
    return null
  }
  if (state.requestScenarioSucceeded) {
    return <Redirect to="/plan/introduction" />
  }
  if (state.deleteSucceeded) {
    return <Redirect to="/plan" />
  }
  const scenarioList = props.scenarios.filter(
    ({ id }) => id !== props.householdState.currentScenarioId
  )

  const { household } = props

  return (
    <>
      <Grid>
        {scenarioList.length > 1 || props.canCreateScenario ? (
          <Grid.Row style={{ borderBottom: "1px solid #d7d7d7" }}>
            <Grid.Column textAlign="center">
              {state.renameMode ? (
                <form
                  onSubmit={e => {
                    e.preventDefault()
                    updateScenarioTitle()
                  }}
                >
                  <Input
                    loading={state.loading}
                    placeholder="Scenario Name"
                    onBlur={updateScenarioTitle}
                    onChange={(_, { value: scenarioTitle }) =>
                      setState(cur => ({ ...cur, scenarioTitle }))
                    }
                    value={
                      state.scenarioTitle || scenario.description || "Untitled"
                    }
                    autoFocus
                  />
                </form>
              ) : (
                <Dropdown
                  text={`${scenario.description || "Untitled"} Scenario`}
                  style={{ textTransform: "uppercase" }}
                >
                  <Dropdown.Menu>
                    {scenarioList.map(scenario => (
                      <Dropdown.Item
                        onClick={async () =>
                          await updateHouseholdState({
                            id: household.id,
                            currentScenarioId: scenario.id
                          })
                        }
                        content={`${scenario.description ||
                          "Untitled"} Scenario`}
                        key={scenario.id}
                        value={scenario.id}
                      />
                    ))}
                    {scenarioList.length > 0 ? <Dropdown.Divider /> : false}
                    <Dropdown.Item
                      value="-1"
                      onClick={() =>
                        setState(cur => ({ ...cur, createMode: true }))
                      }
                    >
                      Create Scenario
                    </Dropdown.Item>
                    {props.scenarios.length > 1 ? (
                      <Dropdown.Item
                        value="-2"
                        onClick={() =>
                          setState(cur => ({ ...cur, confirmDelete: true }))
                        }
                        content={`Delete ${scenario.description ||
                          "Untitled"} Scenario`}
                      />
                    ) : null}
                    <Dropdown.Item
                      content={`Rename ${scenario.description ||
                        "Untitled"} Scenario`}
                      onClick={() =>
                        setState(cur => ({ ...cur, renameMode: true }))
                      }
                      value="-3"
                    />
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </Grid.Column>
          </Grid.Row>
        ) : null}
        <Grid.Row style={{ paddingBottom: "0px" }}>
          <Grid.Column>
            {props.render({
              scenario
            })}
          </Grid.Column>
        </Grid.Row>
      </Grid>
      {state.createMode ? (
        <CreateScenarioModal
          onCancel={() => setState(cur => ({ ...cur, createMode: false }))}
          submit={async (values = {}) => {
            setState(cur => ({
              ...cur,
              createMode: false,
              requestScenarioSucceeded: true
            }))
            createScenario({
              household_id: household.id,
              ...values
            })
          }}
        />
      ) : null}
      {state.confirmDelete ? (
        <AskForConfirmation
          render={() => (
            <span>
              {state.deleteFailed
                ? `Oops!, failed to delete ${scenario.description ||
                    "Untitled"}. Retry?`
                : `You're about to delete ${scenario.description ||
                    "Untitled"} Scenario. Are you sure?`}
            </span>
          )}
          yesLabel={state.deleteFailed ? "Retry" : "Yes"}
          onNo={() => setState(cur => ({ ...cur, confirmDelete: false }))}
          onYes={async () => {
            try {
              setState(cur => ({
                ...cur,
                confirmDelete: false,
                deleteFailed: false,
                deleteSucceeded: true
              }))

              deleteScenario({
                scenario_id: scenario.id,
                household_id: household.id
              })
            } catch (error) {
              setState(cur => ({ ...cur, deleteFailed: true }))
            }
          }}
        />
      ) : null}
    </>
  )
}

export default ScenarioView
